module.exports = __webpack_public_path__ + "assets/20d4e739bcbbbc22e66d0ba750b0125b.png";